import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { CrmEnrichmentQuotaDto } from "../types";

import { quotaQueryKeys } from "./keys";

const useCrmEnrichmentQuotaQuery = () => {
    return useQuery({
        queryKey: quotaQueryKeys.crmEnrichmentQuota(),
        staleTime: Number.POSITIVE_INFINITY,
        queryFn(): Promise<CrmEnrichmentQuotaDto> {
            return salesApiService.quota.fetchCrmEnrichmentQuota();
        },
    });
};

export default useCrmEnrichmentQuotaQuery;
